<template>
  <div>
    <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        <el-form-item label="支付类型">
          <el-select v-model="searchForm.supplier" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          ><el-button size="small" type="primary" icon="el-icon-search"
            >查询</el-button
          ></el-form-item
        >
      </el-form>
    </div>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="id" label="ID" width="150">
      </el-table-column>
      <el-table-column prop="nickname" label="用户昵称" width="150">
      </el-table-column>
      <el-table-column prop="orderNo" label="订单号"> </el-table-column>
      <el-table-column prop="pay_money" label="支付金额"> </el-table-column>
      <el-table-column prop="money" label="赠送金额" width="150">
      </el-table-column>
      <el-table-column prop="order_status_text" label="是否支付" width="150">
      </el-table-column>
      <el-table-column prop="createTime" label="支付时间"> </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    tabhandleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(row) {
      console.log(row);
    },
    handleCurrentChange() {}
  },

  data() {
    return {
      activeName: "first",
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 1,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        createTime: "",
        supplier: ""
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        }
      ],
      tableData: [
        {
          date: "2016-05-02",
          title: "测试",
          name: "王小虎",
          nickname: "llllha",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          orderNo: 200333,
          matinfo: "毛巾",
          pay: "100",
          createTime: "2023年8月29日 12:33",
          order_status_text: "已完成",
          paytype: "微信",
          type: "申请入驻",
          remark: "好",
          id: 1,
          income: "888",
          out: "999",
          collectinfo: "15636369999",
          status_text: "已通过",
          status: 1,
          trans_status: "已转账",
          fee: "0.88",
          invoicing_status: "已寄回",
          header_type: "公司",
          invoice_type: "普通",
          invoice_name: "杭州xxxx公司",
          pay_money: "10000",
          money: "200"
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/cash/invoice/recharge/index.vue